// extracted by mini-css-extract-plugin
module.exports = {"wrapperX":"styles-module--wrapperX--1oLPK","w100":"styles-module--w100--2FWKz"};